import { call, put, takeLatest } from 'redux-saga/effects';
import {
  deleteReservationFromAdminAction,
  deleteReservationFromAdminSuccessAction,
  checkInOutEventReservationAction,
  checkInOutEventReservationSuccessAction,
  confirmReservationAction,
  handleReservationAction,
  handleReservationErrorAction,
  setConfirmReservationSuccessAction,
  setErrorConfirmCheckInOutReservationAction,
  setReservationAction,
  setAddAdminNoteSuccessAction,
  addAdminNoteAction,
  updateIntervalPaymentStatusAction,
  updateIntervalPaymentStatusSuccessAction, setErrorUpdateIntervalPaymentStatusAction,
} from '../../store/admin/handle-reservation.store';
import {
  checkInOutEventReservationAPI,
  confirmReservationAPI,
  retrieveReservationAPI,
  deleteReservationAPI,
  addAdminNoteAPI, updateIntervalPaymentStatusAPI,
} from '../../api/provider/booking/booking-provider';
import { ApiResponse } from '../../api/request';
import { productListAPI } from '../../api/provider/product/product-provider';
import { authenticatedCall } from '../../utils/authenticated-call';

function* handleReservationSaga(data: any) {
  try {
    const roomsAndServicesResponse: ApiResponse = yield call(productListAPI);
    const reservationResponse: ApiResponse = yield authenticatedCall(
      retrieveReservationAPI,
      data.payload,
    );
    yield put(
      setReservationAction({
        reservation: reservationResponse.data.data,
        rooms: roomsAndServicesResponse.data.data,
      }),
    );
  } catch (error: any) {
    yield put(handleReservationErrorAction(error.localizedMessage));
  }
}

function* confirmReservationSaga(data: any) {
  try {
    yield authenticatedCall(confirmReservationAPI, data.payload)
    yield put(setConfirmReservationSuccessAction())
  } catch (error: any) {
    yield put(handleReservationErrorAction(error.localizedMessage))
  }
}

function* addAdminNoteSaga(data: any) {
  try {
    yield authenticatedCall(addAdminNoteAPI, data.payload)
    yield put(setAddAdminNoteSuccessAction())
  } catch (error: any) {
    yield put(handleReservationErrorAction(error.localizedMessage))
  }
}

function* deleteReservationSaga(data: any) {
  try {
    yield authenticatedCall(deleteReservationAPI, data.payload);
    yield put(deleteReservationFromAdminSuccessAction())
  } catch (error: any) {
    yield put(handleReservationErrorAction(error.localizedMessage))
  }
}

function* checkInOutEventReservationSaga(data: any) {
  try {
    yield authenticatedCall(checkInOutEventReservationAPI, data.payload);
    yield put(checkInOutEventReservationSuccessAction(data.payload.dataToSend.action));
  } catch (error: any) {
    yield put(
      setErrorConfirmCheckInOutReservationAction(error.localizedMessage),
    );
  }
}

function* updateIntervalPaymentStatusSaga(data: any) {
  try {
    yield authenticatedCall(updateIntervalPaymentStatusAPI, data.payload);
    yield put(updateIntervalPaymentStatusSuccessAction())
  } catch (error: any) {
    yield put(setErrorUpdateIntervalPaymentStatusAction(error.localizedMessage))
  }
}

export function* handleReservationSagas() {
  yield takeLatest(handleReservationAction.type, handleReservationSaga);
  yield takeLatest(confirmReservationAction.type, confirmReservationSaga);
  yield takeLatest(deleteReservationFromAdminAction.type, deleteReservationSaga);
  yield takeLatest(
    checkInOutEventReservationAction.type,
    checkInOutEventReservationSaga,
  );
  yield takeLatest(addAdminNoteAction.type, addAdminNoteSaga);
  yield takeLatest(updateIntervalPaymentStatusAction.type, updateIntervalPaymentStatusSaga);
}
